import React, { useState, useEffect } from 'react';
import { getMenus, createMenu, updateMenu, deleteMenu, toggleMenuStatus } from '../../services/api';
import DataTable from '../components/DataTable';
import LoadingSpinner from '../components/LoadingSpinner';
import MenuForm from '../forms/MenuForm';
import toast from 'react-hot-toast';

const MenusModule = () => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const fetchMenus = async () => {
    setLoading(true);
    try {
      const response = await getMenus();
      // Handle different response formats
      let menusData = [];
      if (Array.isArray(response)) {
        menusData = response;
      } else if (response.data && Array.isArray(response.data)) {
        menusData = response.data;
      } else if (response.success && response.data) {
        menusData = response.data;
      }
      setMenus(menusData);
      console.log('Menus loaded:', menusData);
    } catch (error) {
      console.error('Error fetching menus:', error);
      toast.error('Error fetching menus');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenus();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this menu?')) {
      try {
        await deleteMenu(id);
        toast.success('Menu deleted successfully');
        fetchMenus();
      } catch (error) {
        toast.error('Error deleting menu');
      }
    }
  };

  const handleToggle = async (id, currentStatus) => {
    try {
      await toggleMenuStatus(id);
      toast.success(`Menu ${currentStatus ? 'deactivated' : 'activated'} successfully`);
      fetchMenus();
    } catch (error) {
      toast.error('Error toggling menu status');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setShowModal(true);
  };

  const columns = ['Order', 'Icon', 'Name', 'Path', 'Status', 'Actions'];

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h2 style={{ color: '#0A192F', fontSize: '1.3rem' }}>Menus ({menus.length})</h2>
        <button 
          onClick={() => {
            setEditingItem(null);
            setShowModal(true);
          }} 
          style={{ padding: '0.5rem 1rem', background: '#2C7A7B', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        >
          <i className="fas fa-plus" /> Add New Menu
        </button>
      </div>
      
      <DataTable 
        items={menus} 
        columns={columns} 
        onEdit={handleEdit} 
        onDelete={handleDelete} 
        onToggle={handleToggle} 
      />
      
      {showModal && (
        <MenuForm 
          editingItem={editingItem} 
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }} 
          onRefresh={fetchMenus} 
        />
      )}
    </div>
  );
};

export default MenusModule;